import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-content">
        <div className="about-header">
          <h1>About us</h1>
        </div>
        <hr />
        <div className="about-text">
          <p>Hello! <br />UFC bot is a website for UFC fans. We help you find best talent fighting in octagon!</p>
          <br />
          <p>Contact: <a href="https://twitter.com/ufcbotcom" target="_blank" rel="noopener noreferrer">https://twitter.com/ufcbotcom</a></p>
          <br />
          <p>More info coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default About; 